// All static data for GirlyGrove — to be swapped with Shopify later.

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_grove-design/artifacts/rwsb6vwa_ChatGPT%20Image%20May%2031%2C%202025%2C%2003_31_16%20PM.png";

// rwsb6vwa = gold pearl drop earrings on peach satin (the showstopper)
export const SAMPLE_IMG_PEARL_DROPS =
  "https://customer-assets.emergentagent.com/job_grove-design/artifacts/rwsb6vwa_ChatGPT%20Image%20May%2031%2C%202025%2C%2003_31_16%20PM.png";
// j2fwe6j5 / lyxugjbw = green-backdrop chain choker (used selectively as accent)
export const SAMPLE_IMG_GREEN_CHOKER =
  "https://customer-assets.emergentagent.com/job_grove-design/artifacts/lyxugjbw_IMG_9128.JPG";
export const SAMPLE_IMG_2 =
  "https://customer-assets.emergentagent.com/job_grove-design/artifacts/j2fwe6j5_IMG_9098.JPG";
// Heart pendant + roses on gold/cream cloth
export const SAMPLE_IMG_HEART_NECKLACE =
  "https://customer-assets.emergentagent.com/job_grove-design/artifacts/qxixvqx9_ChatGPT%20Image%20May%2015%2C%202025%2C%2005_13_03%20PM1.jpg";
export const SAMPLE_IMG_4 =
  "https://customer-assets.emergentagent.com/job_grove-design/artifacts/qxixvqx9_ChatGPT%20Image%20May%2015%2C%202025%2C%2005_13_03%20PM1.jpg";
// Heart hoops + heart necklace on gold satin
export const SAMPLE_IMG_HEART_HOOPS =
  "https://customer-assets.emergentagent.com/job_grove-design/artifacts/5j22gsaw_ChatGPT%20Image%20May%208%2C%202025%2C%2012_29_23%20PM.png";

// ─── Editorial Portraits — user-provided (Feb 2026) ─────────────
// "For Square b1g1" — Milan galleria, pink heart pendant + scarf + sunglasses
export const EDITORIAL_SQUARE_B1G1 =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/f5utun6s_ChatGPT%20Image%20May%2026%2C%202026%2C%2007_18_34%20PM.png";
// "For Square b1g2" — user-uploaded editorial glam box shot
export const EDITORIAL_SQUARE_B1G2 =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/9xjbi08t_ChatGPT%20Image%20Jun%201%2C%202026%2C%2002_39_49%20PM.png";
// "circle b1g1" — user-uploaded circle-fit Mini Box portrait
export const EDITORIAL_CIRCLE_B1G1 =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/y0d4atlc_ChatGPT%20Image%20Jun%209%2C%202026%2C%2004_28_14%20PM.png";
// "circle b1g2" — user-uploaded circle-fit Glam Box portrait
export const EDITORIAL_CIRCLE_B1G2 =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/01x4xadd_ChatGPT%20Image%20Jun%209%2C%202026%2C%2004_23_46%20PM.png";

// Legacy aliases (kept for backward compatibility)
export const EDITORIAL_LAKE_COMO = "/reels/gg2.png";
// Hero right-side portrait — new editorial (Feb 2026): woman's neck + pearl choker (Unsplash)
export const EDITORIAL_SANTORINI =
  "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=900&h=1200&q=90";
export const EDITORIAL_BEACH_HOOP = "/reels/gg5.png";
export const EDITORIAL_MILAN_HEART = "/reels/gg6.png";

// User-provided chunky cuff bracelet images
export const CUFF_IMAGES = [
  "/cuff-1.png",
  "/cuff-2.png",
  "/cuff-3.png",
  "/cuff-4.png",
  "/cuff-5.png",
  "/cuff-6.png",
];

// Curated high-end stock jewelry images (verified URLs)
const STOCK = {
  goldHoops: "https://images.unsplash.com/photo-1535632787350-4e68ef0ac584?auto=format&fit=crop&w=900&q=80",
  pearlChoker: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=900&q=80",
  ringStack: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?auto=format&fit=crop&w=900&q=80",
  charmBracelet: "https://images.unsplash.com/photo-1611652022419-a9419f74343d?auto=format&fit=crop&w=900&q=80",
  pearlStuds: "https://images.unsplash.com/photo-1633934542430-0905ccb5f050?auto=format&fit=crop&w=900&q=80",
  layeredChain: "https://images.unsplash.com/photo-1599643477877-530eb83abc8e?auto=format&fit=crop&w=900&q=80",
  tasselEarrings: "https://images.unsplash.com/photo-1631982690223-8aa4be0a2497?auto=format&fit=crop&w=900&q=80",
  stackBand: "https://images.unsplash.com/photo-1602173574767-37ac01994b2a?auto=format&fit=crop&w=900&q=80",
  jhumka: "https://images.unsplash.com/photo-1535632066927-ab7c9ab8d97a?auto=format&fit=crop&w=900&q=80",
  bangle: "https://images.unsplash.com/photo-1606760227091-3dd870d97f1d?auto=format&fit=crop&w=900&q=80",
  goldChain: "https://images.unsplash.com/photo-1599459183200-59c7687a1d2c?auto=format&fit=crop&w=900&q=80",
  signetRing: "https://images.unsplash.com/photo-1610694955371-d4a3e0ce4b52?auto=format&fit=crop&w=900&q=80",
};

export const CATEGORIES = [
  { id: "earrings", name: "Earrings", sub: "Studs · Hoops · Drops · Korean", image: "/categories/earrings.png" },
  { id: "necklaces", name: "Necklaces", sub: "Chains · Chokers · Pearls", image: "/categories/necklaces.png" },
  { id: "rings", name: "Rings", sub: "Stackable · Adjustable · Statement", image: STOCK.ringStack },
  { id: "bracelets", name: "Bracelets", sub: "Charm · Cuff · Stack", image: STOCK.charmBracelet },
  { id: "cuffs", name: "Chunky Cuffs", sub: "Bold · Sculptural · Statement", image: "/categories/cuff.png" },
  { id: "sets", name: "Sets & Combos", sub: "Curated pairings", image: "/categories/sets.png" },
  { id: "ocean", name: "Ocean Collection", sub: "Riviera · Shells · Sun-touched gold", image: "/categories/ocean.png" },
  { id: "gifts", name: "Gifts & Packaging", sub: "Wrapped with love", image: STOCK.pearlStuds },
];

export const VIBES = [
  {
    id: "petal-mode",
    name: "Petal Mode",
    descriptor: "Soft, feminine, everyday",
    bg: "#FBEAF0",
    text: "#4A2C35",
    accent: "#E8A0B4",
    image: "https://static.prod-images.emergentagent.com/jobs/135bb723-74d6-4365-81f6-e54c103bc90f/images/c5d6e1ffd813c2715193f9f1a06fb9aaef18bc37548a5e80eb58098e04d9a30e.png",
  },
  {
    id: "golden-hour",
    name: "Golden Hour",
    descriptor: "Bold gold, party-ready, festive glow",
    bg: "#C5985A",
    text: "#FDF6F0",
    accent: "#FDF6F0",
    image: "https://static.prod-images.emergentagent.com/jobs/135bb723-74d6-4365-81f6-e54c103bc90f/images/7586a3729e0d6ab9ff24936853a6d31874e6c173f55241a61e3906c642ed98f7.png",
  },
  {
    id: "dark-darling",
    name: "Dark Darling",
    descriptor: "Edgy, moody, statement pieces",
    bg: "#4A2C35",
    text: "#FDF6F0",
    accent: "#E8A0B4",
    image: "https://static.prod-images.emergentagent.com/jobs/135bb723-74d6-4365-81f6-e54c103bc90f/images/a7850abe22e064e60388c13f6fb8837f41a8dc972f9f1c045507f53d47133839.png",
  },
  {
    id: "90s-baby",
    name: "90s Baby",
    descriptor: "Y2K revival, beads, retro hoops",
    bg: "#D4537E",
    text: "#FDF6F0",
    accent: "#FDF6F0",
    image: "https://static.prod-images.emergentagent.com/jobs/135bb723-74d6-4365-81f6-e54c103bc90f/images/6960d2e5a2a68a4fe5b141b1e1b73944dab38d70e21179975c5540012f40f136.png",
  },
  {
    id: "grove-girl",
    name: "Grove Girl",
    descriptor: "Minimal, office-ready, understated",
    bg: "#FDF6F0",
    text: "#4A2C35",
    accent: "#C5985A",
    image: "/vibe-office.png",
  },
];

export const PRODUCTS = [
  {
    id: "p-001",
    name: "Pearl Mist Choker",
    price: 349,
    mrp: 699,
    image: SAMPLE_IMG_HEART_NECKLACE,
    images: [SAMPLE_IMG_HEART_NECKLACE, STOCK.pearlChoker, STOCK.goldChain],
    category: "necklaces",
    vibe: "petal-mode",
    badge: "New",
    isBestseller: true,
    description: "A delicate pearl-and-gold choker that whispers softness. Hypoallergenic, tarnish-resistant brass with 18k gold plating.",
    materials: ["Brass base", "18k gold plating", "Faux pearls"],
    stock: 12,
  },
  {
    id: "p-002",
    name: "Twisted Gold Hoops",
    price: 299,
    mrp: 599,
    image: STOCK.goldHoops,
    images: [STOCK.goldHoops, SAMPLE_IMG_HEART_HOOPS],
    category: "earrings",
    vibe: "golden-hour",
    badge: "Hot",
    isBestseller: true,
    description: "Twisted gold hoops with a sculptural finish — light enough for everyday, bold enough for golden hour.",
    materials: ["Stainless steel", "18k gold plating"],
    stock: 8,
  },
  {
    id: "p-003",
    name: "Vintage Rose Ring Set",
    price: 449,
    mrp: 899,
    image: STOCK.ringStack,
    images: [STOCK.ringStack, STOCK.signetRing],
    category: "rings",
    vibe: "90s-baby",
    badge: "Selling Fast",
    isBestseller: false,
    description: "A romantic stack of three adjustable rings inspired by vintage rose gardens.",
    materials: ["Brass", "Rose-gold finish"],
    stock: 5,
  },
  {
    id: "p-004",
    name: "Celestial Charm Bracelet",
    price: 399,
    mrp: 799,
    image: STOCK.charmBracelet,
    images: [STOCK.charmBracelet],
    category: "bracelets",
    vibe: "dark-darling",
    badge: "New",
    isBestseller: true,
    description: "Moons, stars, evil-eye — wear your tiny universe on your wrist.",
    materials: ["Stainless steel", "Enamel charms"],
    stock: 15,
  },
  {
    id: "p-005",
    name: "Korean Pearl Studs",
    price: 199,
    mrp: 399,
    image: STOCK.pearlStuds,
    images: [STOCK.pearlStuds, SAMPLE_IMG_PEARL_DROPS],
    category: "earrings",
    vibe: "grove-girl",
    badge: null,
    isBestseller: true,
    description: "The perfect everyday studs — soft pearls in a gold bezel.",
    materials: ["Surgical steel", "Faux pearls"],
    stock: 30,
  },
  {
    id: "p-006",
    name: "Layered Chain Necklace",
    price: 549,
    mrp: 1099,
    image: STOCK.layeredChain,
    images: [STOCK.layeredChain, STOCK.goldChain],
    category: "necklaces",
    vibe: "golden-hour",
    badge: "Hot",
    isBestseller: true,
    description: "Three-strand gold chain in graduated lengths — pre-layered, hassle-free.",
    materials: ["Brass", "18k gold plating"],
    stock: 9,
  },
  {
    id: "p-007",
    name: "Statement Tassel Earrings",
    price: 349,
    mrp: 749,
    image: STOCK.tasselEarrings,
    images: [STOCK.tasselEarrings, STOCK.jhumka],
    category: "earrings",
    vibe: "golden-hour",
    badge: "Only 3 Left",
    isBestseller: false,
    description: "Festive tassel earrings that catch the light — and every compliment.",
    materials: ["Brass", "Silk tassels", "Gold plating"],
    stock: 3,
  },
  {
    id: "p-008",
    name: "Stackable Band Ring Set",
    price: 499,
    mrp: 999,
    image: STOCK.stackBand,
    images: [STOCK.stackBand],
    category: "rings",
    vibe: "grove-girl",
    badge: "New",
    isBestseller: false,
    description: "Set of four ultra-thin stackable bands. Minimal, modern, mix-and-match.",
    materials: ["Stainless steel", "Gold & rose-gold plating"],
    stock: 18,
  },
  // Bestsellers extras
  {
    id: "p-009",
    name: "Pearl Drop Statement Earrings",
    price: 449,
    mrp: 899,
    image: SAMPLE_IMG_PEARL_DROPS,
    images: [SAMPLE_IMG_PEARL_DROPS, SAMPLE_IMG_2],
    category: "earrings",
    vibe: "golden-hour",
    badge: "Bestseller",
    isBestseller: true,
    description: "Oversized pearl drops set in glossy gold — the showstopper your collection deserves.",
    materials: ["Brass", "18k gold plating", "Mother-of-pearl"],
    stock: 11,
  },
  {
    id: "p-010",
    name: "Heart Pendant Necklace",
    price: 399,
    mrp: 799,
    image: SAMPLE_IMG_HEART_NECKLACE,
    images: [SAMPLE_IMG_HEART_NECKLACE],
    category: "necklaces",
    vibe: "petal-mode",
    badge: "Bestseller",
    isBestseller: true,
    description: "A puffed gold heart on a delicate snake chain. Wear your softness loud.",
    materials: ["Stainless steel", "18k gold plating"],
    stock: 20,
  },
  {
    id: "p-011",
    name: "Heart Hoop & Necklace Set",
    price: 699,
    mrp: 1399,
    image: SAMPLE_IMG_HEART_HOOPS,
    images: [SAMPLE_IMG_HEART_HOOPS],
    category: "sets",
    vibe: "golden-hour",
    badge: "Set",
    isBestseller: true,
    description: "Matching heart hoops and a heart pendant — the perfect coordinated set.",
    materials: ["Brass", "18k gold plating"],
    stock: 7,
  },
  {
    id: "p-012",
    name: "Golden Temple Drops",
    price: 599,
    mrp: 1199,
    image: STOCK.jhumka,
    images: [STOCK.jhumka],
    category: "earrings",
    vibe: "golden-hour",
    badge: "Festive",
    isBestseller: true,
    description: "Traditional drops reimagined for the modern bride.",
    materials: ["Brass", "Antique gold finish"],
    stock: 6,
  },
  // Chunky Cuffs — using user-provided cuff bracelet imagery
  {
    id: "c-001",
    name: "Rose Garden Chunky Cuff",
    price: 749,
    mrp: 1499,
    image: "/cuff-2.png",
    images: ["/cuff-2.png", "/cuff-1.png"],
    category: "cuffs",
    vibe: "golden-hour",
    badge: "Hot",
    isBestseller: true,
    description: "A sculptural chunky cuff with hand-cast rose & leaf motifs — bold, romantic, statement.",
    materials: ["Brass base", "18k gold plating"],
    stock: 7,
  },
  {
    id: "c-002",
    name: "Scarf-Tied Beaded Cuff",
    price: 649,
    mrp: 1299,
    image: "/cuff-3.png",
    images: ["/cuff-3.png"],
    category: "cuffs",
    vibe: "petal-mode",
    badge: "New",
    isBestseller: false,
    description: "Vintage-inspired beaded cuff that ties with a leopard silk ribbon for adjustable wear.",
    materials: ["Brass", "Gold plating", "Silk scarf"],
    stock: 9,
  },
  {
    id: "c-003",
    name: "Sun Medallion Cuff",
    price: 849,
    mrp: 1699,
    image: "/cuff-4.png",
    images: ["/cuff-4.png"],
    category: "cuffs",
    vibe: "golden-hour",
    badge: "Selling Fast",
    isBestseller: true,
    description: "A statement sun medallion cuff designed to be worn with a printed silk wrap.",
    materials: ["Brass", "Antique gold finish"],
    stock: 4,
  },
  {
    id: "c-004",
    name: "Double Pebble Cuff",
    price: 599,
    mrp: 1199,
    image: "/cuff-5.png",
    images: ["/cuff-5.png"],
    category: "cuffs",
    vibe: "grove-girl",
    badge: "Bestseller",
    isBestseller: true,
    description: "Two oversized polished pebbles fused into a sleek modern cuff — soft luxe at its purest.",
    materials: ["Brass", "Mirror gold plating"],
    stock: 11,
  },
  {
    id: "c-005",
    name: "Hammered Wrap Cuff",
    price: 549,
    mrp: 1099,
    image: "/cuff-6.png",
    images: ["/cuff-6.png"],
    category: "cuffs",
    vibe: "dark-darling",
    badge: "New",
    isBestseller: false,
    description: "Open-end double-band cuff with hand-hammered texture — slips on, never leaves.",
    materials: ["Brass", "Hammered gold finish"],
    stock: 14,
  },
];

export const INSTA_FEED = [
  STOCK.goldHoops,
  SAMPLE_IMG_PEARL_DROPS,
  SAMPLE_IMG_HEART_NECKLACE,
  STOCK.ringStack,
  SAMPLE_IMG_HEART_HOOPS,
  STOCK.layeredChain,
];

// Round circular category icons (sit below hero banner) — mirrors Indian e-commerce UX
export const CATEGORY_CIRCLES = [
  {
    id: "earrings",
    label: "Earrings",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/2yszfuf7_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2009_27_38%20AM.png",
  },
  {
    id: "necklaces",
    label: "Necklaces",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/8r0ejpwl_necklaces.png",
  },
  {
    id: "cuffs",
    label: "Cuffs",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/zfjmfi4l_cuff.png",
  },
  {
    id: "sets",
    label: "Sets",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/01jkdx7u_WhatsApp%20Image%202026-06-01%20at%2015.26.21%282%29.jpeg",
  },
  {
    id: "ocean",
    label: "Ocean",
    image:
      "https://customer-assets.emergentagent.com/job_grove-design/artifacts/woxx6ag9_Ocean%20collection.png",
  },
];

// ─── Pick-Your-Set boxes (used by both square section & Header mega-menu)
export const PICK_YOUR_SET_BOXES = [
  {
    id: "it-girl",
    label: "It-Girl Box",
    price: "₹499",
    pieces: "3 Pieces",
    offerPill: "₹499 · 3 for ₹499",
    image: EDITORIAL_SQUARE_B1G1,
    video:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/f8q33wwh_kling_20260731_VIDEO___Kling_A_4264_0.mp4",
    to: "/bundle/it-girl",
    ribbon: null,
    tagline: "Three pieces that love every outfit back",
    theme: { accent: "#D4537E", bg: "#FFF4F7", border: "rgba(212,83,126,0.38)", pill: "rgba(212,83,126,0.10)", text: "#4A2C35", dark: false },
  },
  {
    id: "glam",
    label: "Glam Box",
    price: "₹799",
    pieces: "5 Pieces",
    offerPill: "₹799 · Mix & Match",
    image: EDITORIAL_SQUARE_B1G2,
    video:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/5oguqkim_kling_20260731_VIDEO__Luxury_It_4229_0.mp4",
    to: "/bundle/glam",
    ribbon: "Most Loved",
    tagline: "Five favourites, one golden steal",
    theme: { accent: "#A87A3A", bg: "linear-gradient(170deg,#FCF3E2 0%,#F6E4C0 100%)", border: "rgba(197,152,90,0.6)", pill: "rgba(197,152,90,0.2)", text: "#4A2C35", dark: false },
  },
  {
    id: "dream",
    label: "Dream Box",
    price: "₹1,199",
    pieces: "7 Pieces + Free Gift",
    offerPill: "₹1,199 + Gift",
    image: EDITORIAL_CIRCLE_B1G2,
    video:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_grove-design/artifacts/f730ef83ac463ac7_kling_20260930_VIDEO_Create_a_1_4470_0.mp4",
    to: "/bundle/dream",
    ribbon: "Best Value · Free Gift",
    gift: "Assured Free Gift Inside",
    tagline: "The whole look. The free gift. The feeling.",
    theme: { accent: "#F4D58D", bg: "linear-gradient(165deg,#5A3542 0%,#2E1A21 100%)", border: "#C5985A", pill: "rgba(244,213,141,0.16)", text: "#FDF6F0", dark: true },
  },
];

// Featured Collections (horizontal scroll editorial cards)
export const COLLECTIONS = [
  {
    id: "chunky-cuffs",
    name: "Chunky Cuffs",
    descriptor: "Bold · Sculptural · New In",
    count: "6 pieces",
    image: "/cuff-lips.png",
    color: "#4A2C35",
    text: "#FDF6F0",
  },
  {
    id: "pearl-edit",
    name: "The Pearl Edit",
    descriptor: "Soft, timeless, modern",
    count: "24 pieces",
    image: SAMPLE_IMG_PEARL_DROPS,
    color: "#F9F2EC",
    text: "#4A2C35",
  },
  {
    id: "korean-picks",
    name: "Korean Picks",
    descriptor: "Minimal · Trending · Soft",
    count: "18 pieces",
    image: STOCK.pearlStuds,
    color: "#FBEAF0",
    text: "#4A2C35",
  },
  {
    id: "golden-hour-edit",
    name: "Golden Hour",
    descriptor: "Bold gold for festive nights",
    count: "32 pieces",
    image: STOCK.layeredChain,
    color: "#D4537E",
    text: "#FDF6F0",
  },
  {
    id: "heart-shapes",
    name: "Heart Shapes",
    descriptor: "Wear your love loud",
    count: "12 pieces",
    image: SAMPLE_IMG_HEART_HOOPS,
    color: "#E8A0B4",
    text: "#4A2C35",
  },
  {
    id: "everyday-luxe",
    name: "Everyday Luxe",
    descriptor: "Office to evening",
    count: "28 pieces",
    image: STOCK.goldHoops,
    color: "#FDF6F0",
    text: "#4A2C35",
  },
  {
    id: "statement-pieces",
    name: "Statement Pieces",
    descriptor: "Bold conversation starters",
    count: "15 pieces",
    image: STOCK.tasselEarrings,
    color: "#4A2C35",
    text: "#FDF6F0",
  },
];

// Instagram reels — user-curated official set.
// Each opens the live reel on instagram.com in a new tab.
export const INSTA_REELS = [
  {
    id: "Dbij-omy2Hl",
    poster: "/reels/gg3.png",
    caption: "Behind the lens · gold cuff styling",
  },
  {
    id: "Da7f9fhomrH",
    poster: "/reels/gg5.png",
    caption: "Everyday gold · office edit",
  },
  {
    id: "DGInIZaodSt",
    poster:
      "https://images.unsplash.com/photo-1611652022419-a9419f74343d?auto=format&fit=crop&w=720&h=1280&q=80",
    caption: "Charm bracelet · how to wear",
  },
  {
    id: "Da7fC6Ao7Eo",
    poster:
      "https://images.unsplash.com/photo-1599643477877-530eb83abc8e?auto=format&fit=crop&w=720&h=1280&q=80",
    caption: "Layering 101 · necklaces",
  },
  {
    id: "DaFHTazyVFz",
    poster:
      "https://images.unsplash.com/photo-1633934542430-0905ccb5f050?auto=format&fit=crop&w=720&h=1280&q=80",
    caption: "Tiny pearl studs · daily wear",
  },
  {
    id: "DN0H6-Z0PSp",
    poster: "/reels/gg1.png",
    caption: "Stacked bangles · pink-shirt edit",
  },
  {
    id: "DMc1VD7Sndr",
    poster:
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=720&h=1280&q=80",
    caption: "Pearl choker · soft luxe moment",
  },
  {
    id: "DJ6wB0_SyX0",
    poster: "/reels/gg2.png",
    caption: "Cafe moments · puff-sleeve dress",
  },
];

export const TRUST_BADGES = [
  { icon: "Truck", title: "Free Delivery", text: "On orders above ₹499" },
  { icon: "BadgeIndianRupee", title: "COD Available", text: "Pay when it arrives" },
  { icon: "Sparkles", title: "Quality Promise", text: "Hypoallergenic, premium finish" },
];

export const MARQUEE_ITEMS = [
  "New arrivals every week",
  "COD available",
  "50,000+ happy customers",
  "Free shipping above ₹499",
  "Korean & Trending styles",
  "Tarnish-free finish",
];

export const NAV_LINKS = [
  { label: "Pick Your Set", to: "/#pick-your-set", icon: "PackageOpen" },
  { label: "Chunky Cuff", to: "/shop?category=cuffs", icon: "Gem" },
  { label: "Ocean Collection", to: "/shop?category=ocean", icon: "Waves" },
  { label: "Set Combos", to: "/shop?category=sets", icon: "Package2" },
  { label: "New In", to: "/shop?filter=new", icon: "Sparkles" },
  { label: "Blog", to: "/blog", icon: "BookOpen" },
];
